import { lazy, Suspense } from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'
import { useApp } from './state/AppContext'
import { AppShell } from './components/AppShell'
import { AuthPage } from './pages/AuthPage'
import { OnboardingPage } from './pages/OnboardingPage'
import { SubscribePage } from './pages/SubscribePage'

const WireframeApp = lazy(() => import('./wireframe/WireframeApp').then((m) => ({ default: m.WireframeApp })))

function Gate() {
  const { mode, user, needsSubscription } = useApp()
  if (mode === 'checking') return <div className="boot"><div className="brand-mark"><span>MÚSICA</span><b>COM.VC</b></div><div className="boot-line" /></div>
  if (!user) return <Navigate to="/entrar" replace />
  if (!user.onboardingComplete) return <Navigate to="/boas-vindas" replace />
  if (mode === 'pocketbase' && needsSubscription) return <Navigate to="/assinar" replace />
  return <AppShell />
}

export function App() {
  return <Routes>
    {import.meta.env.DEV && (
      <Route path="/wireframes/*" element={<Suspense fallback={null}><WireframeApp /></Suspense>} />
    )}
    <Route path="/entrar" element={<AuthPage />} />
    <Route path="/boas-vindas" element={<OnboardingPage />} />
    <Route path="/assinar" element={<SubscribePage />} />
    <Route path="/*" element={<Gate />} />
  </Routes>
}
